import logFactory from 'c9-js-log-client';
import { instanceId } from '../consts/consts';

let logger: ReturnType<typeof logFactory> | undefined;
let formPath: string = 'Unknown Form Path';
let formTitle: string = 'Unknown Form Title';

export const setLogger = (logClient: typeof logger) => {
    logger = logClient;
};

export const loggerSetFormDetails = (title: string, path: string) => {
    formTitle = title;
    formPath = path;
};

export const logError = (message: string) => {
    if (!logger) {
        return Promise.resolve();
    }

    return logger.error(message, instanceId, { customField1: formPath, customField2: formTitle });
};

export const logWarning = (message: string) => {
    if (!logger) {
        return Promise.resolve();
    }

    return logger.warn(message, instanceId, { customField1: formPath, customField2: formTitle });
};

export const logInfo = (message: string, p0: string) => {
    if (!logger) {
        return Promise.resolve();
    }

    return logger.info(message, instanceId, { customField1: formPath, customField2: formTitle });
};

export const logDebug = (message: string) => {
    if (!logger) {
        return Promise.resolve();
    }

    return logger.debug(message, instanceId, { customField1: formPath, customField2: formTitle });
};
